import * as React from "react";
import { getBexApiContext, Context } from "bernie-context";
import { AnalyticsStore, PageStore } from "bernie-core";
import { inject } from "mobx-react";
import { CustomTravelAdvisory } from "./CustomTravelAdvisory";
import { getIdentity } from "../NotificationsWithDialog/NotificationQueryUtils";
import {
  StorefrontWizardRegionTypes,
  StorefrontWizardRegionTypesContext,
} from "src/components/flexComponents/PageLevelProviders/WizardContextProvider/StorefrontWizardRegionTypesContext";

interface CustomTravelAdvisoryWrapperProps {
  context?: Context;
  analytics?: AnalyticsStore;
  location: string;
  page?: PageStore;
  className?: string;
}

export const CustomTravelAdvisoryWrapper: React.FC<CustomTravelAdvisoryWrapperProps> = inject(
  "analytics",
  "context",
  "page"
)((props: CustomTravelAdvisoryWrapperProps) => {
  const { analytics, context, location, page, className = "all-b-margin-three all-t-margin-three" } = props;
  const regionTypeContext = React.useContext(StorefrontWizardRegionTypesContext);
  const bexWizard = regionTypeContext === StorefrontWizardRegionTypes.STOREFRONT_WIZARD_REGION_BEX;

  if (!page || !page.pageId || !context || !bexWizard) {
    return null;
  }

  const identity = getIdentity(page);

  /* istanbul ignore next */
  const analyticsCallback = (rfrr: string, linkName: string | null) => {
    analytics?.trackEvent(rfrr, linkName || "RFRR Action Event", analytics.omnitureData, null, true);
  };

  return (
    <CustomTravelAdvisory
      inputs={{
        context: getBexApiContext(context),
        lineOfBusiness: identity.lineOfBusiness,
        funnelLocation: identity.funnelLocation,
        location,
      }}
      analyticsCallback={analyticsCallback}
      className={className}
    />
  );
});
